import React, { useState, useEffect } from 'react';
import {
    Button,
    Form,
    FormGroup,
    Label,
    Container,
    Row,
    Col
} from 'reactstrap';
import PasswordInput from '../../components/PasswordInput';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { errorToast } from '../../utils/errorToast';
import api from '../../api';
import Package from '../../../package.json';

import './Login.scss';

const ResetPassword = () => {
    const { token } = useParams();
    const navigate = useNavigate();

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    useEffect(() => {
        if (!token) {
            errorToast('Missing or invalid reset token');
            navigate('/login');
        }
    }, [token, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            errorToast('Passwords do not match');
            return;
        }
        try {
            await api.post('/auth/reset', { token, password });
            toast.success('Password has been reset');
            navigate('/login');
        } catch (error) {
            errorToast(error.message || 'Error resetting password');
        }
    };

    return (
        <Container fluid className="login-view bg-broken">
            <Row className="justify-content-center align-items-center min-vh-100">
                <Col className="form-wrap">
                    <div className="text-center">
                        <img src="/logo.svg" alt="Logo" width="220px" />
                    </div>

                    <Form onSubmit={handleSubmit}>
                        <FormGroup>
                            <PasswordInput
                                autoFocus
                                required
                                name="password"
                                id="password"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                            >
                                <Label for="password" className="input-text-label">
                                    New Password
                                </Label>
                            </PasswordInput>
                        </FormGroup>

                        <FormGroup>
                            <PasswordInput
                                required
                                name="confirmPassword"
                                id="confirmPassword"
                                value={confirmPassword}
                                onChange={e => setConfirmPassword(e.target.value)}
                            >
                                <Label for="confirmPassword" className="input-text-label">
                                    Confirm Password
                                </Label>
                            </PasswordInput>
                        </FormGroup>

                        <div className="submit-wrap d-flex flex-column align-items-center">
                            <Button type="submit" color="primary" outline size="lg">
                                Set Password
                            </Button>
                            <div className="version-number">v{Package.version}</div>
                        </div>
                    </Form>
                </Col>
            </Row>
        </Container>
    );
};

export default ResetPassword;
